import { PopupProps } from 'react-popup-manager';
import { ModalDialog } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { CustomAlarmActivationMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.model';
import { getTexts } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.business';
import { CustomAlarmActiveConfirmationModalHeaderComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal-header.component';
import { CustomAlarmActiveConfirmationModalFooterComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal-footer.component';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { useTranslation } from 'core/i18n';
import React from 'react';
import { CustomAlarmModalContent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.style';

export interface CustomAlarmsActiveConfirmationModalComponentProps extends PopupProps {
    customAlarms: CustomAlarmListItem[];
    onConfirm: () => Promise<void>;
    action: CustomAlarmActivationMode;
}

export const CustomAlarmActiveConfirmationModalComponent: React.FC<
    CustomAlarmsActiveConfirmationModalComponentProps
> = (props) => {
    const { t } = useTranslation();
    const { onConfirm, isOpen, onClose, customAlarms, action } = props;

    const [isLoading, setIsLoading] = React.useState(false);

    const texts = getTexts(customAlarms, action);

    const handleConfirm = async () => {
        setIsLoading(true);

        try {
            await onConfirm();
            onClose?.();
        } catch {
            // Let the modal open if errors happen, the notification is already handled by the caller
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ModalDialog
            isOpen={isOpen}
            onClose={onClose}
            title={<CustomAlarmActiveConfirmationModalHeaderComponent customAlarms={customAlarms} action={action} />}
            footerOptions={
                <CustomAlarmActiveConfirmationModalFooterComponent
                    action={action}
                    isLoading={isLoading}
                    onConfirm={handleConfirm}
                />
            }
        >
            <CustomAlarmModalContent>
                <PocTypography variant="body1">{t(texts.bodyText)}</PocTypography>
            </CustomAlarmModalContent>
        </ModalDialog>
    );
};
